/**
 * Client mirror of the server's notes-prefix rule, used only for optimistic
 * display after a save — the server remains authoritative.
 *
 * Ensures the notes start with exactly one "SOF #<sof>" tag: any repeated
 * leading tags (left over from the old append behavior or prior saves) are
 * stripped, then a single tag is prepended with a two-space separator. Because
 * the server now REPLACES the notes (rather than appending), re-saving an
 * edited note stays stable instead of snowballing.
 *
 * @param sof - The SOF number the item belongs to.
 * @param notes - The item's notes as entered by the user.
 * @returns The notes as the server will store them.
 */
export function applyNotesPrefix(
  sof: string,
  notes: string | null | undefined
): string {
  const prefix = 'SOF #' + sof;
  let body = notes ?? '';
  while (body.trimStart().startsWith(prefix)) {
    body = body.trimStart().slice(prefix.length);
  }
  body = body.trimStart();
  return prefix + '  ' + body;
}
